"use client";

import React from "react";

const OVERLAY_BASE_Z_INDEX = 1000;
const OVERLAY_DEPTH_STEP = 10;

export const OverlayDepthContext = React.createContext(0);

export interface OverlayDepthProviderProps {
  children: React.ReactNode;
}

export const OverlayDepthProvider = ({ children }: OverlayDepthProviderProps) => {
  const parentDepth = React.useContext(OverlayDepthContext);
  return <OverlayDepthContext.Provider value={parentDepth + 1}>{children}</OverlayDepthContext.Provider>;
};

export interface UseOverlayZIndexOptions {
  offset?: number;
}

export const useOverlayZIndex = ({ offset = 0 }: UseOverlayZIndexOptions = {}) => {
  const depth = React.useContext(OverlayDepthContext);
  return React.useMemo(() => OVERLAY_BASE_Z_INDEX + depth * OVERLAY_DEPTH_STEP + offset, [depth, offset]);
};

/** Reads the nesting depth of the nearest ancestor overlay, e.g. to re-anchor a dialog rendered elsewhere in the tree (see `useDialog` in Dialog.tsx). */
export const useOverlayDepth = () => React.useContext(OverlayDepthContext);
